module.exports = __webpack_public_path__ + "fonts/DINPro-Bold.34185a04.ttf";